import {AirtableFeedItem} from '../models/airtable';

const MAX_VIDEOS_PER_WINDOW = 3;

/**
 * Distributes video tiles evenly among image tiles to prevent OOM on Android.
 * With 2 columns and ~8 visible items, caps at 3 videos per 8-item window by
 * inserting a video every `spacing` images.
 *
 * Extracted from FeedStore so DiscoverListScreen can apply the same shaping
 * to the paginated TanStack pages without writing through the MobX bridge.
 */
export const distributeVideos = (items: AirtableFeedItem[]): AirtableFeedItem[] => {
  const videos = items.filter(item => item.heroImage?.type === 'video');
  const images = items.filter(item => item.heroImage?.type !== 'video');

  if (videos.length <= MAX_VIDEOS_PER_WINDOW || images.length === 0) {
    return items;
  }

  const spacing = Math.max(2, Math.floor(images.length / videos.length));

  const result: AirtableFeedItem[] = [];
  let videoIndex = 0;

  for (let i = 0; i < images.length; i++) {
    result.push(images[i]);
    if ((i + 1) % spacing === 0 && videoIndex < videos.length) {
      result.push(videos[videoIndex]);
      videoIndex++;
    }
  }

  while (videoIndex < videos.length) {
    result.push(videos[videoIndex]);
    videoIndex++;
  }

  return result;
};
